import { StockStatus } from "@/features/stocks/types/stock.types";

export interface UnavailableDay {
  date: string;
  status: StockStatus;
}

export const STOCK_STATUS_LABEL: Record<StockStatus, string> = {
  [StockStatus.AVAILABLE]: "Disponível",
  [StockStatus.RENTED]: "Alugada",
  [StockStatus.ON_STREET]: "Na rua",
  [StockStatus.MAINTENANCE]: "Em manutenção",
};

/**
 * Converte ISO datetime (`2025-12-01T10:00:00Z`) ou date (`2025-12-01`)
 * para `yyyy-MM-dd` — formato esperado pelo endpoint de disponibilidade.
 */
export function toAvailabilityDate(value: string): string {
  return value.slice(0, 10);
}

export function isFullyAvailable(
  statusByDate: Record<string, StockStatus>,
): boolean {
  return Object.values(statusByDate).every(
    (status) => status === StockStatus.AVAILABLE,
  );
}

export function getUnavailableDays(
  statusByDate: Record<string, StockStatus>,
): UnavailableDay[] {
  return Object.entries(statusByDate)
    .filter(([, status]) => status !== StockStatus.AVAILABLE)
    .map(([date, status]) => ({ date, status }))
    .sort((a, b) => a.date.localeCompare(b.date));
}
